import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputHasAtLeatOneLowerCaseErrorMessage = (
  <Trans>
    Ce champ doit contenir un caractère minuscule
  </Trans>
);
